import { getAllSGRWarrantyRequests } from 'lib/api/sgr';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { Warranty } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import CreateWarrantyDialog from './components/CreateWarrantyDialog';
import WarrantiesTable from './components/WarrantiesTable';
import WarrantyDetailDialog from './components/WarrantyDetailDialog';

const BASE_PAGINATION = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

const SGR = () => {
  const dispatch = useDispatch();
  const [warranties, setWarranties] = useState<Warranty[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [selectedWarranty, setSelectedWarranty] = useState<any>(null);
  const [pagination, setPagination] = useState<Pagination>(BASE_PAGINATION);

  const generateQuery = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    let query = '';
    query += `page=${page}&pageSize=${pageSize}`;
    return query;
  };

  const fetchWarranties = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    setIsLoading(true);
    const query = generateQuery({ page, pageSize });
    try {
      const response = await getAllSGRWarrantyRequests(dispatch, query);
      setWarranties(response.data);
      setPagination(response.pagination);
      return response.data;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenWarrantyDetail = (warrantyId: number) => {
    const warranty = warranties.find((warranty) => warranty.id === warrantyId);
    if (!warranty) return;
    setSelectedWarranty(warranty);
    setOpenDetailDialog(true);
  };

  const handleRefreshWarranties = async (params?: {
    page: number;
    pageSize: number;
  }) => {
    const response = await fetchWarranties({
      page: params?.page ?? pagination.page,
      pageSize: params?.pageSize ?? pagination.pageSize,
    });
    if (response && selectedWarranty) {
      const updatedWarranty = response.find(
        (w: Warranty) => w.id === selectedWarranty.id,
      );
      if (updatedWarranty) setSelectedWarranty(updatedWarranty);
    }
  };

  useEffect(() => {
    void fetchWarranties({
      page: pagination.page,
      pageSize: pagination.pageSize,
    });
  }, []);

  if (isLoading) return <CenteredCircularProgress />;

  return (
    <>
      <WarrantiesTable
        warranties={warranties}
        setWarranties={setWarranties}
        setOpenCreateDialog={setOpenCreateDialog}
        handleOpenWarrantyDetail={handleOpenWarrantyDetail}
        pagination={pagination}
        setPagination={setPagination}
        fetchWarranties={handleRefreshWarranties}
        setIsLoading={setIsLoading}
      />

      <CreateWarrantyDialog
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        fetchWarranties={handleRefreshWarranties}
      />

      <WarrantyDetailDialog
        open={openDetailDialog}
        onClose={() => setOpenDetailDialog(false)}
        warranty={selectedWarranty}
        refreshWarranty={handleRefreshWarranties}
      />
    </>
  );
};

export default SGR;
